import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Hardware from "./components/hardwares/Hardware";
import Footer from "./components/footer/Footer";
import Contactus from "./components/contactus/Contactus";
import Patners from "./components/ourpatners/Patners";
import Uppertopbar from "./components/topbar/uppertopbar/Uppertopbar";
import Lowertopbar from "./components/topbar/lowertopbar/Lowertopbar";
import Homepage from "./pages/homepage/Homepage";
import Servicespage from "./pages/servicespage/Servicespage";
import Quicklinkspage from "./pages/quicklinkspage/Quicklinkspage";
import Aboutus from "./pages/aboutus/Aboutus";
import Whyus from "./pages/whyus/Whyus"
import Loginregister from "./components/loginregister/Loginregister";


function App() {
  return (
    <div className="App">
      <Router>
        <Uppertopbar />
        <Lowertopbar />
        <div className="routescontainer">
          <Switch>
            <Route exact path="/">
              <Homepage />
            </Route>

            <Route exact path="/home">
              <Homepage />
            </Route>

            <Route exact path="/account/*">
              <Loginregister />
            </Route>

            <Route exact path="/quicklinks">
              <Quicklinkspage />
            </Route>

            <Route exact path="/services">
              <Servicespage />
            </Route>

            <Route exact path="/account">
              <Loginregister />
            </Route>
            <Route exact path="/portal">
              <Loginregister />
            </Route>

            <Route axact path="/aboutus">
              <Aboutus />
            </Route>

            <Route exact path="/whyus">
              <Whyus />
            </Route>

            <Route exact path="/contactus">
              <Contactus />
            </Route>

            <Route exact path="/products">
              <Hardware />
            </Route>

            <Route exact path="/patners">
              <Patners />
            </Route>

          </Switch>
        </div>
        <Footer />
      </Router>

    </div>
  );
}

export default App;







